import * as Sentry from "@sentry/browser";

const dsn = import.meta.env.PROD
  ? "https://e380ce3d7afadd1015f424fcb7cafd6b@o4509331568525312.ingest.de.sentry.io/4509354164027472"
  : undefined;

if (dsn) {
  Sentry.init({
    dsn,

    // Vite will replace these values with the actual ones during the build
    environment: import.meta.env.PROD ? "prod" : "local",
    release: import.meta.env.VITE_GIT_SHA,

    integrations: [Sentry.browserTracingIntegration()],

    // Injected by the Microsoft Outlook link scanner, never by a user.
    ignoreErrors: [/Object Not Found Matching Id/],

    // Capture performance traces for 10% of transactions
    tracesSampleRate: 0.1,
  });
}

declare global {
  interface Window {
    sentrySettings?: {
      user?: { id: string; email: string };
      org?: string;
    };
  }
}

if (window.sentrySettings) {
  const { user, org } = window.sentrySettings;
  if (user) {
    Sentry.setUser(user);
  }
  if (org) {
    Sentry.setTag("org", org);
  }
}
